<header>
  <style>
    /* override Bootstrap's container */
    .container-fluid {
        padding-right:0;
        padding-left:0;
        margin-right:auto;
        margin-left:auto
     }
</style>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <a href="https://graphicpkg.com" title="Graphic Packaging International"><img src="./assets/logo.svg" class="brand"
            alt="Graphic Packaging International" /></a>
      </div>
      <div class="col clearfix">
        <a href="#" title="ACES - Online Product Catalogue"><img src="./assets/aceslogo.png"
            class="brand float-right d-none d-md-block" alt="ACES - Online Product Catalogue" /></a>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg navbar-dark bg-graphic sticky-top">
    <a class="navbar-brand d-block d-sm-none" href="#">ACES</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="#" title="Products">Products</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.graphicpkg.com/foodservice-product-brochures/" target="_blank"
            title="Brochures">Brochures</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://etools.graphicpkg.com/" target="_blank" title="E-Tools">E-Tools</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.graphicpkg.com/privacy-policies/" target="_blank"
            title="Privacy Rights & Policies">Privacy Rights & Policies</a>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li class="nav-item" style="padding-right: 10px;" *ngIf="!isAdmin">
          <a class="nav-link" href="javascript:void(0);" (click)="login()" title="Login">Login</a>
        </li>
        <li class="nav-item dropdown" *ngIf="isAdmin">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-expanded="false">
           {{username}}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" href="admin/casepack">Manage Casepacks</a>
            <a class="dropdown-item" href="admin/compatibleitem">Manage Compatible Items</a>
            <a class="dropdown-item" href="admin/material">Manage Materials</a>
            <a class="dropdown-item" href="admin/product">Manage Products</a>
            <a class="dropdown-item" href="admin/printgroup">Manage Print Groups</a>
            <a class="dropdown-item" href="admin/category">Manage Categories</a>
            <a class="dropdown-item" href="admin/subcategory">Manage Subcategories</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="javascript:void(0);" (click)="onLogout()">Logout</a>
          </div>
        </li>
      </ul>

      <form class="form-inline my-2 my-lg-0" (ngSubmit)="OnSubmit()">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"
          [(ngModel)]="searchTerm" name="search">
        <button class="btn btn-outline-light my-2 my-sm-0" type="submit" title="Search"><i
            class="fas fa-search"></i></button>
      </form>
    </div>
  </nav>
</header>